import { QueryClient } from '@tanstack/react-query';

const ONE_HOUR_MS = 60 * 60 * 1000;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

queryClient.setQueryDefaults(['qualify'], {
  gcTime: ONE_HOUR_MS,
});
